import { createRegisterableComposition } from '@news-mono/web-common'
import React from 'react'
import {
    CollectionDataContextProvider,
    CollectionDataContextProviderProps,
} from './CollectionDataContext'

export const CollectionDataContextRegistration =
    createRegisterableComposition<'children'>()(
        'collection-data-context',
        ({ children }, { contextId }: CollectionDataContextProviderProps) => (
            <CollectionDataContextProvider contextId={contextId}>
                {children}
            </CollectionDataContextProvider>
        ),
    )
